import Grid from "@mui/material/Grid2";
import styles from "./LandingPage.module.css";
import { Box, Card, Typography, useMediaQuery } from "@mui/material";
import {
  AboutUsLine,
  GmailLogo,
  InstagramLogo,
  LocationIcon,
  WhatasappIcon,
} from "../../svgImage";
import defxLogo from "../../assets/DefxLogo.png";

const ContactUs = () => {
  const isMobile = useMediaQuery("(max-width:468px)");

  const handleGmailCardClick = () => {
    const email = "shreeprasadam135@gmail.com";
    const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}`;
    window.open(gmailUrl, "_blank");
  };
  const handleWhatsappClick = () => {
    const phoneNumber = "+918980593216";
    const whatsappUrl = `https://wa.me/${phoneNumber}`;
    window.open(whatsappUrl, "_blank");
  };
  const handleInstagramProfileClick = (userName) => {
    const instagramProfileUrl = `https://www.instagram.com/${userName}`;
    window.open(instagramProfileUrl, "_blank");
  };
  const onDirectToDefx = () => {
    window.open("https://defx.in/", "_blank");
  };

  return (
    <Grid
      container
      marginTop="100px"
      flexDirection={"column"}
      justifyContent={"center"}
      rowGap={4}
      pt={4}
      pb={4}
      bgcolor={"#986633"}
    >
      <Grid
        maxWidth="940px"
        margin="auto"
        width="100%"
        px={{ xs: "clamp(12px, 4vw, 24px)", md: 0 }} // dynamic padding
      >
        <Box
          display="flex"
          alignItems={{ xs: "flex-start", sm: "center" }}
          justifyContent="space-between"
          flexDirection={{ xs: "column", sm: "row" }}
          gap={{ xs: 2, sm: 0 }}
        >
          {/* LEFT: Title */}
          <Typography
            className={styles.contactUsTitle}
            paddingLeft={{ xs: 1, sm: 0 }}
            paddingRight={{ xs: 1, sm: 0 }}
            textAlign={{ xs: "left", sm: "inherit" }}
          >
            Contact us
          </Typography>

          {/* RIGHT: Location + Text */}
          <Box
            display="flex"
            alignItems="flex-start"
            gap={1}
            mt={{ xs: 1, sm: 0 }}
          >
            <LocationIcon style={{ minWidth: 24 }} />

            <Typography
              className={styles.contactusDiscription}
              maxWidth={{ xs: "100%", sm: "350px" }}
            >
              Nalanda Complex, 118, near MANSI CIRCLE, above Vala’s gym, Mahavir
              Nagar society, Vastrapur, Ahmedabad, Gujarat 380015
            </Typography>
          </Box>
        </Box>
      </Grid>

      <Grid maxWidth={"940px"} margin={"auto"} width={"100%"}>
        <Grid
          container
          sx={{
            justifyContent: {
              xs: "center",
              sm: "center",
              md: "space-between",
            },
          }}
          display={"flex"}
          rowGap={5}
          columnGap={2}
        >
          {/* WhatsApp */}
          <Grid display={"flex"} flexDirection={"column"}>
            <Box margin={"auto"}>
              <WhatasappIcon />
            </Box>
            <Card
              className={styles.footerContactCard}
              onClick={handleWhatsappClick}
            >
              <Typography className={styles.ContactCardText}>
                +91-89805 93216
              </Typography>
            </Card>
          </Grid>

          {/* Instagram */}
          <Grid display={"flex"} flexDirection={"column"}>
            <Box margin={"auto"}>
              <InstagramLogo />
            </Box>
            <Card className={styles.footerContactCard}>
              <Typography
                className={styles.ContactCardText}
                onClick={() =>
                  handleInstagramProfileClick("gifting.byprasadam")
                }
              >
                @gifting.byprasadam
              </Typography>
              <Typography
                className={styles.ContactCardText}
                onClick={() => handleInstagramProfileClick("umami.byprasadam")}
              >
                @umami.byprasadam
              </Typography>
              <Typography
                className={styles.ContactCardText}
                onClick={() =>
                  handleInstagramProfileClick("shreeprasadam.co.in")
                }
              >
                @shreeprasadam.co.in
              </Typography>
            </Card>
          </Grid>

          {/* Gmail */}
          <Grid display={"flex"} flexDirection={"column"}>
            <Box margin={"auto"}>
              <GmailLogo />
            </Box>
            <Card
              className={styles.footerContactCard}
              onClick={handleGmailCardClick}
            >
              <Typography className={styles.ContactCardText}>
                shreeprasadm135@gmail.com
              </Typography>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ContactUs;
